module.exports = __webpack_public_path__ + "e3a2d2e60d0b6328adc44f4cbeda41fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/calibre/calibre.svg
// module id = 1520
// module chunks = 0